// todo implement
/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosError } from 'axios';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AdditionalQuestion } from 'types/additionalQuestion';
import { api } from 'services/api';
import { initialMeta } from 'services/initialStates';
// import { FormPage } from './FormPage';
import { Loading } from 'common/components/Loading';
import { LoadingError } from 'common/components/LoadingError';
import { FullScreen } from 'styles/FullScreen';
import { Meta } from 'types/meta';
import { BackgroundImage } from 'styles/BackgroundImage';

export const CustomFormPage: FC = () => {
  const { hash } = useParams() as { hash: string };
  const { t } = useTranslation();
  const [formLoading, setFormLoading] = useState(true);
  const [companyHash, setCompanyHash] = useState<string>('');
  const [location, setLocation] = useState<string | undefined>('');
  const [name, setName] = useState<string | undefined>('');
  const [phone, setPhone] = useState<string | undefined>('');
  const [additionalQuestions, setAdditionalQuestions] = useState<
    AdditionalQuestion[]
  >([]);
  const [orderType, setOrderType] = useState('');
  const [formLoadingError, setFormLoadingError] = useState(false);
  const [_formLoadingErrorText, setFormLoadingErrorText] = useState('');
  const [meta, setMeta] = useState<Meta>(initialMeta);

  useEffect(() => {
    setFormLoading(true);
    api()
      .getHashData(hash)
      .then(data => {
        setCompanyHash(data.company_hash);
        setLocation(data.location_hash);
        setName(data.name);
        setPhone(data.phone);
        setOrderType(data.order_type);
        if (data.additional_questions != null)
          setAdditionalQuestions(data.additional_questions);
        return api()
          .getCompany(data.company_hash)
          .then(response => {
            setMeta(response.meta);
            setFormLoading(false);
          });
      })
      .catch((error: AxiosError) => {
        error.response?.status === 422
          ? setFormLoadingErrorText(t('validationError'))
          : setFormLoadingErrorText(t('errorTryAgain'));
        setFormLoadingError(true);
        setFormLoading(false);
      });
  }, []);

  if (formLoading) return <Loading />;
  if (formLoadingError)
    return <LoadingError error={t('failedToRetrieveCompanyData')} />;

  return (
    <FullScreen>
      <BackgroundImage source={meta.background} />
      {/* <FormPage
        showLocations={location ? false : true}
        companyHash={companyHash}
        locationHash={location}
        additionalQuestions={additionalQuestions}
        orderType={orderType}
        anonymous={anonymousReview}
        name={name}
        phone={phone}
        hash={hash}
      /> */}
    </FullScreen>
  );
};
